import { initWidget } from '../../utils/Shell';
import GSRegistrationWidget from './GSRegistrationWidget.vue';

initWidget('GSRegistrationWidget', GSRegistrationWidget);
